angular.module('flipto.components.common.modalFieldsEditor', ['flipto.components.common.fieldEditors'])
    .directive('ftModalFieldsEditor', [
        '$compile', '$q', '$templateCache', '$http', '$timeout', 'fieldEditor', 'ftModal',
        function ($compile, $q, $templateCache, $http, $timeout, FieldEditor, ftModal) {

            var modalFieldsEditorTemplate = '/app/components/common/modal-fields-editor/modalFieldsEditor.html';

            function fetchTemplate(template) {
                return $q.when($templateCache.get(template) || $http.get(template))
                    .then(function (res) {
                        return angular.isObject(res) && res.data || res;
                    });
            }

            function deepEval(scope, expression) {
                var ctx = scope;
                while (ctx) {
                    try {
                        var val = ctx.$eval(expression);
                        if (val !== undefined) return val;
                    } catch (e) {}
                    ctx = ctx.$parent;
                }
                return undefined;
            }

            return {
                restrict: 'A',
                require: 'ftModalFieldsEditor',
                link: function (scope, element, attrs, controller) {
                    var disabled;
                    var modalId;
                    var currentModalEl = null;
                    var currentFieldEl = null;
                    var fieldContainerSelector = 'ft-' + attrs.editorType + '-field';

                    attrs.$observe('disabled', function (val) {
                        disabled = val === 'true';
                    });

                    function renderModal(fieldsValue, fieldsExpression) {
                        if (currentModalEl && modalId && ftModal.isOpen(modalId)) {
                            renderFieldOnly(fieldsValue, fieldsExpression);
                            return;
                        }

                        const source = {
                            fields: fieldsValue,
                            fieldsExpression: fieldsExpression,
                            trimclipboardformat: attrs.trimclipboardformat || false,
                            readonlytext: attrs.readonlytext || '',
                            fieldsOptions: attrs.fieldsOptions && deepEval(scope, attrs.fieldsOptions),
                            tokens: attrs.tokens || '',
                            description: attrs.editorDescription || '',
                            title: attrs.editorTitle || '',
                            type: attrs.editorType,
                            datasource: attrs.datasource,
                            snapshot: attrs.snapshot || attrs.datasource,
                            onDone: attrs.onDone,
                            onCancel: attrs.onCancel,
                            size: attrs.size || ''
                        };

                        const fieldEditor = new FieldEditor(source);
                        const fieldEditorHtml = fieldEditor.getHtml();

                        fetchTemplate(modalFieldsEditorTemplate).then(function (contents) {
                            modalId = 'modal-' + Date.now() + Math.floor(Math.random() * 1000);

                            contents = contents
                                .replace('[modal-id]', modalId)
                                .replace('[field-editor]', fieldEditorHtml)
                                .replace('[modal description]', source.description)
                                .replace('[snapshot]', source.snapshot)
                                .replace('[modal title]', source.title)
                                .replace('[on-done]', source.onDone)
                                .replace('[on-cancel]', source.onCancel)
                                .replace('[size]', source.size);

                            currentModalEl = angular.element(contents);
                            angular.element(document).find('body').append(currentModalEl);
                            $compile(currentModalEl)(scope);

                            $timeout(() => {
                                currentFieldEl = currentModalEl[0].querySelector(fieldContainerSelector);
                            });

                            element.bind("click", function () {
                                !disabled && ftModal.show(modalId);
                            });

                            scope.$on("$destroy", function () {
                                element.unbind("click");
                            });
                        });
                    }

                    function renderFieldOnly(fieldsValue, fieldsExpression) {
                        if (!currentModalEl) return;

                        const source = {
                            fields: fieldsValue,
                            fieldsExpression: fieldsExpression,
                            type: attrs.editorType,
                            datasource: attrs.datasource,
                            readonlytext: attrs.readonlytext || '',
                            trimclipboardformat: attrs.trimclipboardformat || false,
                            tokens: attrs.tokens || '',
                            fieldsOptions: attrs.fieldsOptions && deepEval(scope, attrs.fieldsOptions)
                        };

                        const newFieldEditor = new FieldEditor(source);
                        const newFieldHtml = newFieldEditor.getHtml();
                        const newFieldEl = angular.element(newFieldHtml);

                        const oldFieldEl = currentModalEl[0].querySelector(fieldContainerSelector);
                        if (oldFieldEl) {
                            const parentEl = angular.element(oldFieldEl).parent();
                            angular.element(oldFieldEl).remove();
                            parentEl.append(newFieldEl);
                            $compile(newFieldEl)(scope);
                            currentFieldEl = newFieldEl[0];
                        }
                    }

                    function updateModalFromFields() {
                        const fieldsExpression = attrs.fields;
                        const fieldsValue = deepEval(scope, fieldsExpression);
                        renderModal(fieldsValue, fieldsExpression);
                    }

                    $timeout(() => {
                        scope.$evalAsync(updateModalFromFields);
                    });

                    if (attrs.fields) {
                        scope.$watch(() => deepEval(scope, attrs.fields), function (newVal, oldVal) {
                            if (!angular.equals(newVal, oldVal)) {
                                renderFieldOnly(newVal, attrs.fields);
                            }
                        }, true);
                    }
                },
                controller: ['$scope', function ($scope) {}]
            };
        }
    ]);
